import React, { useState } from 'react';

interface CollapsibleSectionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  icon?: string;
  guidanceButton?: React.ReactNode;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  children,
  defaultOpen = true,
  className = '',
  icon,
  guidanceButton
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`collapsible-section ${className}`}>
      <div 
        className={`section-header ${isOpen ? 'open' : 'closed'}`} 
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="header-left">
          {icon && <span className="section-icon">{icon}</span>}
          <h3 className="section-title">{title}</h3>
          <span className={`chevron ${isOpen ? 'up' : 'down'}`}>
            {isOpen ? '▲' : '▼'}
          </span>
        </div>
        {guidanceButton && (
          <div className="header-right" onClick={(e) => e.stopPropagation()}>
            {guidanceButton}
          </div>
        )}
      </div>
      
      <div className={`section-content ${isOpen ? 'open' : 'closed'}`}>
        <div className="content-inner">
          {children}
        </div>
      </div>
    </div>
  );
};

export default CollapsibleSection;